const Features = () => {

    const features = [
        {
            name : "Time & Attendance Tracking",
            desc : " Automate check-ins and check-outs, ensuring accurate work hour logs for employees and freelancers."
        },
        {
            name : "Project Costing & Budgeting",
            desc : "Monitor budgets with precision, ensuring every project stays profitable."
        },
        {
            name : "Billing & Invoicing",
            desc : "Convert tracked hours into invoices seamlessly, reducing manual effort and errors."
        },
        {
            name : "Payroll Integration",
            desc : "Ensure accurate payroll processing by linking time tracking with your preferred payroll system."
        },
        {
            name : "Resource Management",
            desc : "Allocate team resources efficiently and track utilization in real time."
        },
        {
            name : "Workforce Planning",
            desc : "Plan employee shifts efficiently, ensuring optimal workforce allocation and productivity."
        },
        {
            name : "Custom Reporting & Analytics",
            desc : "Generate customizable reports with insights into productivity, efficiency, and time utilization."
        }
    ];

    return (
        <div id="features-container">
            <img id="feature-bg-img" src="/svg/features-page.svg" alt="bg-image" />
            <p id="heading">Track Time, Boost Productivity, Stay on top of your Business</p>
            <div id="features-wrapper">
                {
                    features.map((feature, index) => {
                        var cardStyle = {borderRadius : "59px"};
                        switch(index){
                            case 0 : 
                                cardStyle.borderTopLeftRadius = 0;
                                break;
                            case 2 :
                                cardStyle.borderTopRightRadius = 0;
                                break;
                            case 6 : 
                                cardStyle.borderBottomLeftRadius = 0;
                                break;
                            case 8 :
                                cardStyle.borderBottomRightRadius = 0;
                                break;
                        }
                        return(
                            <div key={index} style={cardStyle} className="card">
                                <div className="card-front">
                                    <p className="card-heading">{feature.name}</p>
                                    <p>{feature.desc}</p>
                                </div>
                                <div className="card-back">
                                    <img src="images/temp1.png" width="100%" height="100%" alt="temp" />
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
  )
}

export default Features
